
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 37.25 37.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.21 11.43l1.41 2.38c.41.73.79 1.47 1.18 2.15h.06c.38-.77.74-1.5 1.12-2.21l1.26-2.32h4.85l-4.73 6.85 4.79 7.53h-5.06l-1.44-2.59c-.41-.7-.76-1.44-1.12-2.17h-.09c-.35.76-.73 1.47-1.09 2.17L16 25.81h-4.91l4.88-7.32-4.76-7.06z","fill":"#f2f2f2"}}),_c('path',{attrs:{"d":"M18.62 37.25a18.63 18.63 0 1118.63-18.62 18.65 18.65 0 01-18.63 18.62zm0-36.25a17.63 17.63 0 1017.63 17.63A17.64 17.64 0 0018.62 1z","fill":"#f2f2f2"}})])
          )
        }
      }
    